import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MessageContext } from "../../../../../common/message";
import { cleanJoin, cutShort } from "../../../../../utils/stringUtil";
import { UPLOAD_STATUS } from "../upload/DocumentUpload";
import Box from "../../../../../common/box/Box";
import { getAccessToken } from "../../../../../common/authorization/AuthorizeService";
import { select } from "../PreviewDocumentsUtils";
function DocumentUploadProgress({
  id,
  doc,
  dispatchUpdateAction,
  RemoveAttachment,
  color,
  setSelected,
}) {
  const message = useContext(MessageContext);
  const [displayProgress, setDisplayProgress] = useState(false);
  const [displayRemoveAttachment, setDisplayRemoveAttachment] = useState(RemoveAttachment);
  const [fileName, setFileName] = useState("");
  const { t } = useTranslation();

  useEffect(() => {
    setDisplayProgress(
      doc.uploadStatus === UPLOAD_STATUS.IN_PROGRESS || doc.uploadStatus === UPLOAD_STATUS.ERROR
    );

    setDisplayRemoveAttachment(doc.uploadStatus === UPLOAD_STATUS.SUCCESS);

    if (color === "green") {
      setDisplayProgress(doc.uploadStatus !== UPLOAD_STATUS.NOT_STARTED);
      setDisplayRemoveAttachment(false);
      doc.uploadStatus = 4;
      setFileName(doc.href == null ? "" : doc.href.split("_user_").pop().split("&")[0]);
    }

    if (color === "grey" && doc.href !== null) {
      /* setDisplayProgress(doc.uploadStatus !== UPLOAD_STATUS.NOT_STARTED); */
      setDisplayRemoveAttachment(true);
      doc.uploadStatus = 4;
      setFileName(doc.href == null ? "" : doc.href.split("_user_").pop().split("&")[0]);
    }
  }, [doc.uploadStatus, doc, color]);

  useEffect(() => {
    if (doc.uploadProgress === 100 && doc.file !== null && doc.done !== true) {
      doc.uploadStatus === UPLOAD_STATUS.SUCCESS &&
        message.toggle({
          title: t("modalMessage.titleInfo"),
          content: t("requests.decisionAcceptance.action.added"),
          hideNo: true,
          hideX: false,

          yesLabel: t("modalMessage.okLabel"),
          onNo: () => {
            doc.done = true;
            message.toggle({});
          },
          onYes: () => {
            doc.done = true;
            if (doc.href !== null) {
              message.toggle({});
              select("supplementDocs", id, null, null, setSelected);
            }
          },
        });
    }
  }, [doc.uploadStatus]);

  return (
    <Box
      isBorderless={true}
      defaultPadding={false}
      className={cleanJoin(
        "has-text-weight-bold",
        displayRemoveAttachment ? "p-2 has-background-white-ter" : "p-0",
        doc.uploadStatus === UPLOAD_STATUS.NOT_STARTED ? "is-hidden" : "",
        color === "green" ? "p-2 has-background-white-ter" : "p-0"
      )}
    >
      {doc.uploadStatus !== UPLOAD_STATUS.NOT_STARTED && (
        <button
          target="_blank"
          className={"button is-light has-background-white-ter is-size-7 has-text-weight-bold"}
          rel="noopener noreferrer"
          onClick={async () => {
            message.toggle({
              show: true,
              title: "",
              content: t("requests.wait.label"),
              hideNo: true,
              hideYes: true,
              isWait: true,
              hideX: false,
            });
            fetch(`${process.env.REACT_APP_GATEWAY_URL}${doc.href}`, {
              method: "GET",
              headers: {
                "Request-Origin": "pisarnica",
                Authorization: "Bearer " + (await getAccessToken()),
                "Content-Type": "application/pdf",
              },
              mode: "cors",
              credentials: "include",
            })
              .then((response) => response.blob())
              .then(
                (file) => window.open(URL.createObjectURL(file)) && message.toggle({ show: false })
              );
          }}
        >
          {cutShort(doc.file !== null ? doc.file.name : fileName, 35, "...")}
        </button>
      )}
      {displayRemoveAttachment && (
        <>
          <FontAwesomeIcon
            onClick={() => {
              message.toggle({
                title: t("requests.reviewDocuments.upload.deleteAttachmentMessageTitle"),
                content: t("requests.reviewDocuments.upload.deleteAttachmentMessage"),
                onNo: () => message.toggle({}),
                onYes: () => {
                  doc.done = false;
                  doc.uploadStatus = UPLOAD_STATUS.NOT_STARTED;
                  doc.uploadError = null;
                  doc.uploadProgress = 0;
                  doc.file = null;
                  doc.href = null;

                  dispatchUpdateAction();

                  message.toggle({});
                },
              });
            }}
            className="is-pulled-right mt-2 ml-4 is-clickable"
            icon={faTimes}
            title={t("requests.reviewDocuments.upload.deleteAttachment")}
          />
        </>
      )}

      {displayProgress && color === "grey" && (
        <progress className="ml-2" value={doc.uploadProgress} max="100" />
      )}
      {displayProgress && color === "green" && <progress className="ml-2" value="100" max="100" />}
    </Box>
  );
}

export default DocumentUploadProgress;
